import React from 'react'
import TranslationCont from '../General/TranslationCont'

const MoviePersonsAccess = ({persons, transId}) => {
    if(!persons || 0 === persons.length) {
        return ''
    }

    const filteredPersons = persons.filter(p => p.name)

    if(0 === filteredPersons.length) {
        return ''
    }

    return (
        <>
            <dt><TranslationCont id={transId} after=':'>Personen</TranslationCont></dt>
            {filteredPersons.map(({name}, index) => <dd key={index}>{name}</dd>)}
        </>
    )

}

export default MoviePersonsAccess